import { CurrentOrderStatsDto, KnownOrderStatus } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Paths, ProjectPathParams } from '../../../../../app/router/app.router';
import { StatusBooked } from '../../../../../ui/components/pure/icons/StatusBooked.icon';
import { StatusCancelled } from '../../../../../ui/components/pure/icons/StatusCancelled.icon';
import { StatusCollected } from '../../../../../ui/components/pure/icons/StatusCollected.icon';
import { StatusDelivered } from '../../../../../ui/components/pure/icons/StatusDelivered.icon';
import { StatusInProgress } from '../../../../../ui/components/pure/icons/StatusInProgess.icon';
import { StatusOverdue } from '../../../../../ui/components/pure/icons/StatusOverdue.icon';
import { StatusRetrievalRequired } from '../../../../../ui/components/pure/icons/StatusRetrievalRequired.icon';
import { StatusRetrieved } from '../../../../../ui/components/pure/icons/StatusRetrieved.icon';
import { SVGIconComponent } from '../../../../../ui/components/pure/icons/types';
import { useDashboardStats } from '../../../hooks/useDashboardStats';
import { usePathFromStatusCountCard } from '../../../hooks/usePathFromStatusCountCard';
import { StatusCountCardLarge } from '../status-count-card-large/status-count-card-large.component';
import { StatusCountCardSmall } from '../status-count-card-small/status-count-card-small.component';

export function RetailStatusCountCard({
  status,
  params,
  size,
  showSubtitle = true
}: {
  status: KnownOrderStatus;
  params: ProjectPathParams<Paths.dashboard>;
  size: 'large' | 'small';
  showSubtitle?: boolean;
}) {
  const { currentStats } = useDashboardStats(params.projectID);
  const link = usePathFromStatusCountCard(params, status);

  const Component = size === 'small' ? StatusCountCardSmall : StatusCountCardLarge;

  return (
    <Component
      status={status}
      count={currentStats.currentMergedStats.data?.statuses[statusCountKeyMap[status]]}
      isLoading={currentStats.currentMergedStats.isLoading}
      link={link}
      Icon={statusIconMap[status]}
      showSubtitle={showSubtitle}
    />
  );
}

const statusCountKeyMap: Record<KnownOrderStatus, keyof CurrentOrderStatsDto['statuses']> = {
  'in-progress': 'inProgress',
  'retrieval-required': 'retrievalRequired',
  booked: 'booked',
  cancelled: 'cancelled',
  collected: 'collected',
  delivered: 'delivered',
  'delivered-offline': 'deliveredOffline',
  overdue: 'overdue',
  retrieved: 'retrieved'
};

const statusIconMap: Record<KnownOrderStatus, SVGIconComponent> = {
  'in-progress': StatusInProgress,
  'retrieval-required': StatusRetrievalRequired,
  booked: StatusBooked,
  cancelled: StatusCancelled,
  collected: StatusCollected,
  delivered: StatusDelivered,
  'delivered-offline': StatusInProgress,
  overdue: StatusOverdue,
  retrieved: StatusRetrieved
};
